/* eslint-disable */
import { defineFakeRoute } from 'vite-plugin-fake-server/client'

interface MockDataIn {
    [key: string]: string | number | MockDataIn[] | string[]
}

const mockData: MockDataIn[] = []

for (let i = 0; i < 40; i++) {
    mockData.push({
        type: '系统通知',
        value: `您有一条新消息${i}`,
        date: '2023-08-25',
    })
}

export default defineFakeRoute([
    {
        url: '/mock/notification-list',
        method: 'get',
        response: (request: any) => {
            const { pageSize, currentPage } = request.query
            const start = (currentPage - 1) * pageSize
            const end = Number(start) + Number(pageSize)
            return {
                error: '',
                status: 1,
                data: mockData.slice(start, end),
                total: mockData.length,
            }
        }
    },
])